export default __webpack_public_path__ + "smo-logo-rounded.a2ca55241b20b43cece2967e5feaed8f.svg";